export function trimStrings(obj: any): any {
  if (typeof obj === "string") {
    return obj.trim();
  } else if (typeof obj === "object" && obj !== null) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key] = trimStrings(obj[key]);
      }
    }
  }
  return obj;
}
